import { render, staticRenderFns } from "./TractTypeSettings.vue?vue&type=template&id=4bfab8ef&"
import script from "./TractTypeSettings.vue?vue&type=script&lang=js&"
export * from "./TractTypeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports